import type { Size } from '@/types/common.types';

export const ICON_SIZE_MAP: Record<Size, number> = {
  xsmall: 12,
  small: 16,
  medium: 20,
  large: 24,
  xlarge: 50,
};

export const EV_ICON_ARRAY = [
  'ev-icon-zoomout',
  'ev-icon-zoomin',
  'ev-icon-workflow',
  'ev-icon-window',
  'ev-icon-window-minimize',
  'ev-icon-window-maximize',
  'ev-icon-warning3',
  'ev-icon-warning2',
  'ev-icon-warning',
  'ev-icon-visibility',
  'ev-icon-visibility-off',
  'ev-icon-user2',
  'ev-icon-user',
  'ev-icon-user-plus2',
  'ev-icon-user-plus',
  'ev-icon-user-minus',
  'ev-icon-user-delete',
  'ev-icon-user-check',
  'ev-icon-upload',
  'ev-icon-unlock2',
  'ev-icon-unlock',
  'ev-icon-undo',
  'ev-icon-triangle-up',
  'ev-icon-triangle-down',
  'ev-icon-trash3',
  'ev-icon-trash2',
  'ev-icon-trash',
  'ev-icon-topology',
  'ev-icon-tool',
  'ev-icon-timeline',
  'ev-icon-time2',
  'ev-icon-time',
  'ev-icon-time-line',
  'ev-icon-text-vertical',
  'ev-icon-text-up',
  'ev-icon-terminal',
  'ev-icon-sun',
  'ev-icon-stop2',
  'ev-icon-stop1',
  'ev-icon-square-plus',
  'ev-icon-square-minus',
  'ev-icon-square-double-up',
  'ev-icon-square-double-right',
  'ev-icon-square-double-left',
  'ev-icon-square-double-down',
  'ev-icon-square-arrow-up',
  'ev-icon-square-arrow-right',
  'ev-icon-square-arrow-left',
  'ev-icon-square-arrow-down',
  'ev-icon-spinner',
  'ev-icon-spark',
  'ev-icon-shovel',
  'ev-icon-share',
  'ev-icon-shard',
  'ev-icon-server2',
  'ev-icon-server',
  'ev-icon-search2',
  'ev-icon-search',
  'ev-icon-search-chart',
  'ev-icon-save',
  'ev-icon-s-time-backward',
  'ev-icon-s-stop',
  'ev-icon-s-step-forward',
  'ev-icon-s-step-backward',
  'ev-icon-s-square-plus',
  'ev-icon-s-square-minus',
  'ev-icon-s-resume',
  'ev-icon-s-plus',
  'ev-icon-s-play',
  'ev-icon-s-pause',
  'ev-icon-s-panel-out',
  'ev-icon-s-minus',
  'ev-icon-s-hamburger',
  'ev-icon-s-forward',
  'ev-icon-s-double-up',
  'ev-icon-s-double-right',
  'ev-icon-s-double-left',
  'ev-icon-s-double-down',
  'ev-icon-s-close',
  'ev-icon-s-backward',
  'ev-icon-s-back',
  'ev-icon-s-arrow-up',
  'ev-icon-s-arrow-right',
  'ev-icon-s-arrow-left',
  'ev-icon-s-arrow-down',
  'ev-icon-RTM',
  'ev-icon-replicaset',
  'ev-icon-registration',
  'ev-icon-refresh3',
  'ev-icon-refresh2',
  'ev-icon-refresh',
  'ev-icon-redo',
  'ev-icon-radio-on2',
  'ev-icon-radio-on',
  'ev-icon-radio-off2',
  'ev-icon-radio-off',
  'ev-icon-r',
  'ev-icon-question',
  'ev-icon-query',
  'ev-icon-printer',
  'ev-icon-plus',
  'ev-icon-plus-16px',
  'ev-icon-plug',
  'ev-icon-play_circle',
  'ev-icon-pin',
  'ev-icon-pig',
  'ev-icon-piece',
  'ev-icon-pencil',
  'ev-icon-panel-out',
  'ev-icon-PA',
  'ev-icon-ok',
  'ev-icon-notice',
  'ev-icon-node',
  'ev-icon-network-twoway',
  'ev-icon-network-oneway',
  'ev-icon-network-division',
  'ev-icon-network-check',
  'ev-icon-moon',
  'ev-icon-monitor',
  'ev-icon-monitor-grid',
  'ev-icon-monitor-chart',
  'ev-icon-mobius',
  'ev-icon-minus',
  'ev-icon-menu2',
  'ev-icon-menu',
  'ev-icon-memory2',
  'ev-icon-memory',
  'ev-icon-Medium',
  'ev-icon-manual2',
  'ev-icon-manual',
  'ev-icon-Low',
  'ev-icon-logout3',
  'ev-icon-logout2',
  'ev-icon-logout',
  'ev-icon-login',
  'ev-icon-lock2',
  'ev-icon-lock2_line',
  'ev-icon-lock',
  'ev-icon-list',
  'ev-icon-link',
  'ev-icon-link-off',
  'ev-icon-License',
  'ev-icon-layout',
  'ev-icon-kafka',
  'ev-icon-Information',
  'ev-icon-info2',
  'ev-icon-info',
  'ev-icon-hive2',
  'ev-icon-hive',
  'ev-icon-highlight-on',
  'ev-icon-highlight-off',
  'ev-icon-High',
  'ev-icon-help',
  'ev-icon-hamburger2',
  'ev-icon-hamburger',
  'ev-icon-group',
  'ev-icon-grid',
  'ev-icon-grid-script',
  'ev-icon-grid-plus',
  'ev-icon-grid-minus',
  'ev-icon-grid-check',
  'ev-icon-getmore',
  'ev-icon-gear',
  'ev-icon-gauge',
  'ev-icon-funnel',
  'ev-icon-folder2',
  'ev-icon-folder',
  'ev-icon-folder-share',
  'ev-icon-folder-plus',
  'ev-icon-folder-open',
  'ev-icon-folder-minus',
  'ev-icon-folder-merge',
  'ev-icon-flow2',
  'ev-icon-flow',
  'ev-icon-filter2',
  'ev-icon-filter',
  'ev-icon-filter-list',
  'ev-icon-external-link3',
  'ev-icon-external-link2',
  'ev-icon-external-link',
  'ev-icon-expand2',
  'ev-icon-expand',
  'ev-icon-exchange',
  'ev-icon-Error2',
  'ev-icon-error',
  'ev-icon-elapse2',
  'ev-icon-elapse',
  'ev-icon-edit',
  'ev-icon-download',
  'ev-icon-double-square',
  'ev-icon-done',
  'ev-icon-dolphin',
  'ev-icon-document',
  'ev-icon-document-vertically',
  'ev-icon-document-share',
  'ev-icon-document-search',
  'ev-icon-document-script',
  'ev-icon-document-move',
  'ev-icon-document-merge',
  'ev-icon-document-horizontally',
  'ev-icon-document-edit',
  'ev-icon-document-division2',
  'ev-icon-document-division',
  'ev-icon-document-copy2',
  'ev-icon-document-copy',
  'ev-icon-document-a',
  'ev-icon-description',
  'ev-icon-descending',
  'ev-icon-db2',
  'ev-icon-db',
  'ev-icon-db-plus',
  'ev-icon-db-minus',
  'ev-icon-db-delete',
  'ev-icon-Dashboard',
  'ev-icon-cpu',
  'ev-icon-cpu-2',
  'ev-icon-connection',
  'ev-icon-connection-line',
  'ev-icon-configuration',
  'ev-icon-configuration-line',
  'ev-icon-compress2',
  'ev-icon-compress',
  'ev-icon-column',
  'ev-icon-collapse2',
  'ev-icon-collapse',
  'ev-icon-cluster',
  'ev-icon-cloud_upload',
  'ev-icon-close3',
  'ev-icon-close2',
  'ev-icon-close',
  'ev-icon-circle-plus',
  'ev-icon-circle-minus',
  'ev-icon-circle-arrow-up',
  'ev-icon-circle-arrow-right',
  'ev-icon-circle-arrow-left',
  'ev-icon-circle-arrow-down',
  'ev-icon-check-on2',
  'ev-icon-check-on',
  'ev-icon-check-off2',
  'ev-icon-check-off',
  'ev-icon-chart-pie',
  'ev-icon-chart-line',
  'ev-icon-chart-line-plus',
  'ev-icon-chart-line-minus',
  'ev-icon-chart-bar',
  'ev-icon-change',
  'ev-icon-calendar2',
  'ev-icon-calendar',
  'ev-icon-calendar-two',
  'ev-icon-calendar-plus',
  'ev-icon-calendar-one',
  'ev-icon-calendar-minus',
  'ev-icon-briefcase',
  'ev-icon-binder',
  'ev-icon-binary',
  'ev-icon-bell2',
  'ev-icon-bell',
  'ev-icon-bell-warning',
  'ev-icon-bell-line',
  'ev-icon-avatar2',
  'ev-icon-avatar',
  'ev-icon-ascending',
  'ev-icon-arrow-up',
  'ev-icon-arrow-right2',
  'ev-icon-arrow-right',
  'ev-icon-arrow-left2',
  'ev-icon-arrow-left',
  'ev-icon-arrow-down2',
  'ev-icon-arrow-down',
  'ev-icon-arrow-check',
  'ev-icon-allow2-up',
  'ev-icon-allow2-right2',
  'ev-icon-allow2-right',
  'ev-icon-allow2-left2',
  'ev-icon-allow2-left',
  'ev-icon-allow2-down',
  'ev-icon-all-check',
  'ev-icon-alert4',
  'ev-icon-alert3',
  'ev-icon-add',
  'ev-icon-add-box',
  'ev-icon-active',
] as const;

export const ICON_ARRAY = [
  'icon-replication-standby',
  'icon-replication-primary',
  'icon-replication-primary-writer',
  'icon-replication-replica-read',
  'icon-topology-pin',
  'icon-outlined-line-chart',
  'icon-cloud',
  'icon-dashboard',
  'icon-dashboard-regular',
  'icon-report-bold',
  'icon-pa-bold',
  'icon-real-time',
  'icon-singleview',
  'icon-objectmap',
  'icon-report',
  'icon-trendview',
  'icon-settings',
  'icon-support',
  'icon-db',
  'icon-db-fill',
  'icon-pa',
  'icon-zoom',
  'icon-zoom-reset',
  'icon-graph',
  'icon-location',
  'icon-expandview',
  'icon-application',
  'icon-infrastructure',
  'icon-logout',
  'icon-direction',
  'icon-arrow-up',
  'icon-arrow-down',
  'icon-arrow-left',
  'icon-arrow-right',
  'icon-arrow-right2',
  'icon-arrow-outward',
  'icon-2arrow-up',
  'icon-2arrow-down',
  'icon-2arrow-left',
  'icon-2arrow-right',
  'icon-remove',
  'icon-add',
  'icon-close',
  'icon-equal',
  'icon-menu',
  'icon-filter-list',
  'icon-check',
  'icon-responsive-check',
  'icon-fullscreen',
  'icon-fullscreen-exit',
  'icon-expand',
  'icon-restore',
  'icon-360',
  'icon-send-copy',
  'icon-share',
  'icon-share-dashboard',
  'icon-check-circle',
  'icon-warning',
  'icon-fill-warning',
  'icon-error-circle',
  'icon-arrow-circle-up',
  'icon-time',
  'icon-link',
  'icon-link-chain',
  'icon-search',
  'icon-zoom-in',
  'icon-zoom-out',
  'icon-star-half',
  'icon-star',
  'icon-calendar',
  'icon-bookmark',
  'icon-outline-copy',
  'icon-outline-copy-2',
  'icon-copy-to-clipboard',
  'icon-copy-layers',
  'icon-notifications',
  'icon-notifications-mute',
  'icon-slider',
  'icon-left-panel',
  'icon-right-panel',
  'icon-outline-align-left',
  'icon-align-top',
  'icon-align-middle',
  'icon-align-bottom',
  'icon-outline-align-center',
  'icon-outline-align-right',
  'icon-outline-align-right-simple',
  'icon-outline-align-justify',
  'icon-spuit',
  'icon-image',
  'icon-refresh',
  'icon-arrow-back',
  'icon-arrow-forward',
  'icon-outline-arrow-up',
  'icon-outline-arrow-down',
  'icon-fill-arrow-up',
  'icon-fill-arrow-down',
  'icon-fill-arrow-left',
  'icon-fill-arrow-right',
  'icon-fill-2arrow-up',
  'icon-fill-2arrow-down',
  'icon-fill-2arrow-left',
  'icon-fill-2arrow-right',
  'icon-stepper',
  'icon-swap',
  'icon-apps',
  'icon-more-horizon',
  'icon-more-vertical',
  'icon-change',
  'icon-plus-circle',
  'icon-outlined-add-circle',
  'icon-minus-circle',
  'icon-close-circle',
  'icon-fill-check-circle',
  'icon-fill-error-circle',
  'icon-plus-square',
  'icon-pause-square',
  'icon-minus-square',
  'icon-arrow-down-circle',
  'icon-arrow-up-circle',
  'icon-arrow-left-circle',
  'icon-arrow-right-circle',
  'icon-fill-time',
  'icon-chart',
  'icon-sand-clock',
  'icon-time-outline',
  'icon-history',
  'icon-play',
  'icon-download',
  'icon-fill-download',
  'icon-build',
  'icon-outlined-build',
  'icon-favorite',
  'icon-fill-star',
  'icon-visibility',
  'icon-visibility-off',
  'icon-visibility-outline',
  'icon-visibility-off-outline',
  'icon-fill-db',
  'icon-fill-notifications',
  'icon-notification-important',
  'icon-plugin',
  'icon-memory',
  'icon-message',
  'icon-billing-mail',
  'icon-system',
  'icon-sms',
  'icon-mobile',
  'icon-pin',
  'icon-pin-outline',
  'icon-push-pin',
  'icon-fill-bookmark',
  'icon-fill-share',
  'icon-place',
  'icon-outline-edit',
  'icon-lock',
  'icon-unlock',
  'icon-group',
  'icon-flag',
  'icon-cs',
  'icon-fill-settings',
  'icon-tablespace',
  'icon-index',
  'icon-table',
  'icon-table2',
  'icon-export-table',
  'icon-outline-delete',
  'icon-brush',
  'icon-safety',
  'icon-pause',
  'icon-cpu',
  'icon-memory-limit',
  'icon-running',
  'icon-palette',
  'icon-info-circle',
  'icon-help-circle',
  'icon-k8s',
  'icon-container',
  'icon-desktop',
  'icon-reset',
  'icon-node',
  'icon-pod',
  'icon-service',
  'icon-bell',
  'icon-inbox',
  'icon-shield',
  'icon-color-opentelemetry',
  'icon-drag-menu',
  'icon-widget-time-series',
  'icon-widget-scatter',
  'icon-scatter-scatter-basic',
  'icon-scatter-scatter-long-term',
  'icon-widget-one-day-compare',
  'icon-widget-equalizer',
  'icon-widget-stacked-proportion-bar',
  'icon-widget-exclusive',
  'icon-widget-status',
  'icon-widget-status-summary',
  'icon-widget-topology',
  'icon-widget-service-card',
  'icon-status-summary-pi',
  'icon-widget-pie',
  'icon-widget-group',
  'icon-widget-memo',
  'icon-widget-text',
  'icon-widget-image',
  'icon-widget-gauge',
  'icon-widget-heatmap',
  'icon-widget-tab-group',
  'icon-time-series-line',
  'icon-time-series-area',
  'icon-time-series-bar',
  'icon-time-series-stacked-area',
  'icon-time-series-stacked-bar',
  'icon-one-day-compare-line',
  'icon-one-day-compare-bar',
  'icon-widget-scoreboar',
  'icon-scoreboard-style-1',
  'icon-scoreboard-style-2',
  'icon-pie-pie',
  'icon-widget-action-vie',
  'icon-action-view-style-1',
  'icon-action-view-style-2',
  'icon-action-view-style-3',
  'icon-heatmap-current-heatmap',
  'icon-monitor',
  'icon-critical',
  'icon-warning-yellow',
  'icon-warning-red',
  'icon-widget-table',
  'icon-table-table',
  'icon-table-top-3-card',
  'icon-widget-top-lis',
  'icon-top-list-summary-bar',
  'icon-top-list-summary-card',
  'icon-widget-tree-gri',
  'icon-tree-grid-tree-grid',
  'icon-widget-horizontal-filter',
  'icon-widget-vertical-filter',
  'icon-widget-realtime',
  'icon-widget-by-period',
  'icon-realtime-card-list',
  'icon-realtime-scoreboard',
  'icon-realtime-alert-table',
  'icon-realtime-scoreboard-table',
  'icon-realtime-pie',
  'icon-by-period-pie',
  'icon-by-period-line',
  'icon-by-period-alert-table',
  'icon-status-hexa',
  'icon-status-summary-card',
  'icon-topology-topology',
  'icon-service-card-style-1',
  'icon-service-card-style-2',
  'icon-fill-service',
  'icon-empty-smile',
  'icon-kubernetes',
  'icon-server-bold',
  'icon-dns-bold',
  'icon-private-cloud-bold',
  'icon-public-cloud-bold',
  'icon-hybrid-cloud-bold',
  'icon-dmz-bold',
  'icon-internet-bold',
  'icon-intranet-bold',
  'icon-person',
  'icon-home',
  'icon-key',
  'icon-card',
  'icon-thumbs-up',
  'icon-handshake',
  'icon-pets',
  'icon-label',
  'icon-polymer',
  'icon-mail',
  'icon-circle',
  'icon-work',
  'icon-bar-chart',
  'icon-stacked-line-chart',
  'icon-qr-code',
  'icon-pin-drop',
  'icon-outline-folder',
  'icon-file',
  'icon-hexagon',
  'icon-flight',
  'icon-school',
  'icon-toys-fan',
  'icon-waves',
  'icon-fertile',
  'icon-mindfulness',
  'icon-nightlight',
  'icon-rander',
  'icon-security',
  'icon-coffee',
  'icon-deployment-bold',
  'icon-scaling-bold',
  'icon-dev-ops-intergration-bold',
  'icon-pods-containers-bold',
  'icon-management-bold',
  'icon-container-management-bold',
  'icon-performance-bold',
  'icon-oracle-text',
  'icon-database-bold',
  'icon-select-file',
  'icon-infrastructure-bold',
  'icon-kubernetes-bold',
  'icon-node-bold',
  'icon-application-bold',
  'icon-service-bold',
  'icon-java-bold',
  'icon-python-bold',
  'icon-dotnet-bold',
  'icon-dotnet-framework-bold',
  'icon-nodejs-bold',
  'icon-exclusive-style-1',
  'icon-exclusive-style-2',
  'icon-exclusive-style-3',
  'icon-experiment',
  'icon-icon',
  'icon-list',
  'icon-application-normal',
  'icon-application-warning',
  'icon-application-critical',
  'icon-database-normal',
  'icon-database-warning',
  'icon-database-critical',
  'icon-infrastructure-normal',
  'icon-infrastructure-warning',
  'icon-infrastructure-critical',
  'icon-kubernetes-normal',
  'icon-kubernetes-warning',
  'icon-kubernetes-critical',
  'icon-cube',
  'icon-no-icon',
  'icon-no-icon-config',
  'icon-graphs-widget',
  'icon-architecture-widget',
  'icon-list-widget',
  'icon-service-widget',
  'icon-text-widget',
  'icon-image-widget',
  'icon-alert-widget',
  'icon-line-chart',
  'icon-grid',
  'icon-grid2',
  'icon-heatmap',
  'icon-alert',
  'icon-alert-off',
  'icon-alert-bell',
  'icon-color-message',
  'icon-color-slack',
  'icon-color-telegram',
  'icon-color-sms',
  'icon-color-webhook',
  'icon-color-archiving',
  'icon-color-on-site',
  'icon-kakaotalk',
  'icon-upload',
  'icon-status-total',
  'icon-status-waiting',
  'icon-status-pending',
  'icon-status-running',
  'icon-status-succeeded',
  'icon-status-terminated',
  'icon-status-failed',
  'icon-status-unknown',
  'icon-stat-square',
  'icon-stat-square-light',
  'icon-fill-color-star',
  'icon-add-chart',
  'icon-move-to-inbox',
  'icon-oracle',
  'icon-postgresql',
  'icon-mysql',
  'icon-sqlserver',
  'icon-mongo',
  'icon-mongodb',
  'icon-cubrid',
  'icon-tibero',
  'icon-altibase',
  'icon-altibase-replication',
  'icon-clickhouse',
  'icon-clickhouse-graphic',
  'icon-redshift',
  'icon-singlestore',
  'icon-oracle-mono',
  'icon-postgresql-mono',
  'icon-redis-mono',
  'icon-mysql-mono',
  'icon-sqlserver-mono',
  'icon-mongodb-mono',
  'icon-mongo-mono',
  'icon-clickhouse-mono',
  'icon-cubrid-mono',
  'icon-tibero-mono',
  'icon-altibase-mono',
  'icon-clickhouse-mono',
  'icon-redshift-mono',
  'icon-singlestore-mono',
  'icon-java',
  'icon-dotnet',
  'icon-dotnet-framework',
  'icon-nodejs',
  'icon-python',
  'icon-php',
  'icon-golang',
  'icon-golang-character',
  'icon-kafka',
  'icon-redis',
  'icon-tomcat',
  'icon-apache',
  'icon-elasticsearch',
  'icon-prometheus',
  'icon-trino',
  'icon-trino-mono',
  'icon-exemone',
  'icon-intermax',
  'icon-maxgauge',
  'icon-nginx',
  'icon-solr',
  'icon-message-queue',
  'icon-cluster',
  'icon-zookeeper',
  'icon-javascript',
  'icon-activemq',
  'icon-glusterfs',
  'icon-weblogic',
  'icon-jeu',
  'icon-webtob',
  'icon-iis',
  'icon-azure',
  'icon-azure-blob-storage',
  'icon-azure-cache-for-redis',
  'icon-azure-cache-for-redis-enterprise',
  'icon-azure-cosmos-db',
  'icon-azure-database-for-mariadb',
  'icon-azure-database-for-mysql',
  'icon-azure-database-for-postgresql',
  'icon-azure-sql-database',
  'icon-azure-virtual-machines',
  'icon-aws',
  'icon-aws-ec2',
  'icon-aws-ecs',
  'icon-aws-s3',
  'icon-aws-rds',
  'icon-aws-lambda',
  'icon-aws-aurora',
  'icon-aws-dynamodb',
  'icon-aws-lightsail',
  'icon-aws-sagemaker',
  'icon-aws-vpc',
  'icon-aws-documentdb',
  'icon-aws-redshift',
  'icon-aws-costexplorer',
  'icon-aws-elasticache',
  'icon-aws-dms',
  'icon-ncp',
  'icon-k8s-cluster-with-bg',
  'icon-k8s-node',
  'icon-k8s-node-with-bg',
  'icon-k8s-namespace',
  'icon-k8s-pod',
  'icon-k8s-container',
  'icon-k8s-job',
  'icon-k8s-cronjob',
  'icon-k8s-daemonset',
  'icon-k8s-deployment',
  'icon-k8s-replicaset',
  'icon-k8s-statefulset',
  'icon-ingress-controller',
  'icon-ingress',
  'icon-widget-server',
  'icon-server-server',
  'icon-featured-dashboard',
  'icon-featured-report',
  'icon-dashboard-shared',
  'icon-linux',
  'icon-apim',
  'icon-java-batch',
  'icon-tmax',
  'icon-unix',
  'icon-windows',
  'icon-aix',
  'icon-kubernetes-primary',
  'icon-child-right',
  'icon-hp',
  'icon-multi',
  'icon-featured-host',
  'icon-featured-host-color',
  'icon-featured-infrastructure',
  'icon-featured-message-queue',
  'icon-featured-application',
  'icon-featured-log',
  'icon-featured-sms',
  'icon-featured-cloud',
  'icon-warning-cloud',
  'icon-featured-user',
  'icon-mysql-color',
  'icon-sqlserver-color',
  'icon-host',
  'icon-broker',
  'icon-active-controller',
  'icon-alert-check-by-combination',
  'icon-alert-check-by-target',
  'icon-opacity',
  'icon-timeline',
  'icon-timeline-fill',
  'icon-reset-outline',
  'icon-group-dashboard-shared',
  'icon-share-fill',
  'icon-collapse-outline',
  'icon-expand-outline',
  'icon-filter-outline',
  'icon-horizontal-divider',
  'icon-area-chart',
  'icon-outlined-chart',
  'icon-outline-link-off',
  'icon-outlined-format-list-bulleted',
  'icon-outlined-hexagon',
  'icon-network-object',
  'icon-network-object-2',
  'icon-outlined-account-tree',
  'icon-outlined-folder-open',
  'icon-outlined-key',
  'icon-pause-square',
  'icon-network',
  'icon-database',
  'icon-loading',
  'icon-overview',
  'icon-outline-cast',
  'icon-circle-spinner',
  'icon-stop-circle',
  'icon-diff',
  'icon-popup-logout',
  'icon-popup-info',
  'icon-popup-language',
  'icon-popup-group',
  'icon-popup-settings',
  'icon-popup-theme',
  'icon-trash-outline',
  'icon-page-outline',
  'icon-restore-outline',
  'icon-polygon',
  'icon-increase-arrow-color',
  'icon-decrease-arrow-color',
  'icon-export',
  'icon-sorting-default',
  'icon-sorting-asc',
  'icon-sorting-desc',
  'icon-folder',
  'icon-shell-script',
  'icon-shell-script-with-bg',
  'icon-database-with-bg',
  'icon-sunos',
  'icon-redhat',
  'icon-suse',
  'icon-network-node',
  'icon-network-switch',
  'icon-network-router',
  'icon-network-firewall',
  'icon-network-aruba',
  'icon-network-fortigate',
  'icon-network-server',
  'icon-network-accesspoint',
  'icon-network-device',
  'icon-network-tms',
  'icon-network-ips',
  'icon-network-storage',
  'icon-network-security',
  'icon-network-3d',
  'icon-network-accesspoint-3d',
  'icon-network-security-3d',
  'icon-network-firewall-3d',
  'icon-network-tms-3d',
  'icon-network-ips-3d',
  'icon-network-storage-3d',
  'icon-network-server-3d',
  'icon-network-router-3d',
  'icon-network-switch-3d',
  'icon-network-device-3d',
  'icon-network-idc-center-3d',
  'icon-network-idc-center-2-3d',
  'icon-network-object-3d',
  'icon-code',
  'icon-performance-event',
  'icon-user-event',
  'icon-browser-event',
  'icon-screen',
  'icon-capture',
  'icon-checked-blue',
  'icon-chevron-down',
  'icon-duration',
  'icon-start-circle',
  'icon-share-dashboard',
  'icon-share-outline',
  'icon-outlined-feed',
  'icon-infrastructure-3d',
  'icon-azure',
  'icon-fill-edit',
  'icon-fill-delete',
  'icon-cloud-bold',
  'icon-application-3d',
  'icon-cloud-3d',
  'icon-database-3d',
  'icon-kubenetes-3d',
  'icon-host-3d',
  'icon-message-queue-3d',
  'icon-namespace-color',
  'icon-websphere',
  'icon-kafka-mono',
  'icon-jeus-mono',
  'icon-oracle-application-server',
  'icon-resin',
  'icon-jboss',
  'icon-glassfish',
  'icon-jetty',
  'icon-aws-cloudwatch',
  'icon-aws-database-migration',
  'icon-k8s-pod-color',
  'icon-k8s-pvc',
  'icon-k8s-deployment-color',
  'icon-k8s-configmap-color',
  'icon-k8s-hpa-color',
  'icon-k8s-ingress-color',
  'icon-k8s-service-color',
  'icon-k8s-service-with-bg',
  'icon-k8s-pvc-with-bg',
  'icon-k8s-configmap-with-bg',
  'icon-k8s-hpa-with-bg',
  'icon-k8s-pod-with-bg',
  'icon-k8s-deployment-with-bg',
  'icon-k8s-replicaset-with-bg',
  'icon-k8s-namespace-with-bg',
  'icon-network-object-color',
  'icon-azure-virtual-machines',
  'icon-azure-sql',
  'icon-azure-database-mysql',
  'icon-azure-database-postgresql',
  'icon-azure-database-mariadb',
  'icon-azure-cache-redis',
  'icon-azure-functions',
  'icon-azure-blob-storage',
  'icon-azure-cosmos-db',
  'icon-cisco-systems',
  'icon-juniper-networks',
  'icon-huawei',
  'icon-arista-networks',
  'icon-hpe-aruba-networks',
  'icon-fortigate',
  'icon-palo-alto-networks',
  'icon-dell-emc',
  'icon-extreme-networks',
  'icon-nokia',
  'icon-host-color',
  'icon-mono',
  'icon-golang-color',
  'icon-windows-color',
  'icon-aix-color',
  'icon-linux-color',
  'icon-hp-color',
  'icon-hpux-color',
  'icon-nginx-color',
  'icon-tomcat-color',
  'icon-apache-color',
  'icon-php-color',
  'icon-kubernetes-3d',
  'icon-nvidia',
  'icon-ai-bubble',
  'icon-outlined-table',
  'icon-outlined-rest-api',
  'icon-aws-aurora-and-mysql',
  'icon-aws-aurora-and-postgresql',
  'icon-aws-rds-and-mysql',
  'icon-aws-rds-and-oracle',
  'icon-aws-rds-and-postgresql',
  'icon-tree-map-outline',
  'icon-jeus-color',
  'icon-popup-window',
  'icon-add-folder',
  'icon-circle-hexagon',
  'icon-circle-hexagon-linked',
  'icon-circle-triangle',
  'icon-color-check-circle',
  'icon-alert-no-data',
  'icon-connection-test',
  'icon-database-upload',
  'icon-loading-blue',
  'icon-postgresql-primary',
  'icon-postgresql-standby',
  'icon-enter',
  'icon-option',
  'icon-widgets',
  'icon-brick',
  'icon-move-down',
  'icon-text-fields',
  'icon-circle-signal',
  'icon-table-horiz',
  'icon-table-vertical',
  'icon-rect-align-left',
  'icon-rect-align-center',
  'icon-rect-align-right',
  'icon-rect-align-top',
  'icon-rect-align-middle',
  'icon-rect-align-bottom',
  'icon-rect-distribute-horizontal',
  'icon-rect-distribute-vertical',
  'icon-drop-widget',
  'icon-k8s-pv-with-bg',
  'icon-k8s-storage-class-with-bg',
  'icon-fan-normal',
  'icon-fan-fail',
  'icon-psu-normal',
  'icon-psu-fail',
  'icon-health',
  'icon-aiops',
] as const;

export const ALL_ICON_SET = new Set<string>([...EV_ICON_ARRAY, ...ICON_ARRAY]);
